<div class="header-content">
  <div slot="start" class="logo-container">
    <span class="flex-row">
      <span class="logo"></span>
      <span class="logo-text">
        <p class="h1">Promo</p>
        <p class="h1">Portal</p>
      </span>
    </span>
  </div>

  <ion-buttons slot="end" class='anonymous-buttons'>
    <ion-button shape='round' (click)="goToPage('auth/login')" class='anonymous-button fadeIn delay-1s5'>
      Log into Promo Portal
    </ion-button>
    <ion-button shape='round' (click)="onWhatIsPpClick()" class='anonymous-button fadeIn delay-2s'>
      What is Promo Portal?
    </ion-button>
  </ion-buttons>
</div>
